import styled from "styled-components";

export const InfoContainer = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ lightBg }) =>
    lightBg ? "var(--creme-white)" : "var(--primary-color)"};
`;

export const InfoWrapper = styled.div`
  display: grid;
  z-index: 1;
  //height: 800px;
  width: 100%;
  padding: 100px 20px;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  justify-content: center;

  @media screen and (max-width: 768px) {
    width: 100%;
    //height: 1024px;
  }
`;

export const InfoRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col2 col1'` : `'col1 col2'`};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;

export const Column1 = styled.div`
  //margin-bottom: 15px;
  padding: 0 25px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  //margin-bottom: 15px;
  padding: 0 25px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  //padding-bottom: 60px;
`;

export const TopLine = styled.p`
  color: ${({ lightText }) =>
    lightText ? "var(--custom-white-opacity)" : "var(--primary-color)"};
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) =>
    lightText ? "var(--custom-white)" : "var(--primary-color)"};

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: ${({ lightText }) =>
    lightText ? "var(--custom-white-opacity)" : "var(--primary-color)"};
`;

// export const BtnWrap = styled.div`
//   display: flex;
//   justify-content: flex-start;
// `;

export const ImgWrap = styled.div`
  //max-width: 555px;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;

  //background-color: var(--accent-color);
  /*background: rgb(158, 155, 201);
  background: radial-gradient(
    circle,
    rgba(158, 155, 201, 1) 0%,
    rgba(32, 25, 128, 1) 100%
  );*/
  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
  }

  @media screen and (max-width: 768px) {
    padding-top: 50px;
  }
`;

export const Img = styled.img`
  width: 100%;
  margin: auto;
  margin: 0 0 10px 0;
  border-radius: 20px;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: row;
  gap: 10px;
`;

export const IconWrapper = styled.div`
  width: 30px;
  height: 30px;
`;
